/**
 * PROJECTSピックアップエリア
 */

import ResizeWatch from '../utils/ResizeWatch';
import AnyStore from "../common/AnyStore";

export default class projectsPickup {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'projectsPickup';
    this.elSelector = '.l-projects-pick';

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    this.resizeUpdate();
    ResizeWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {

  }

  /**
   * 任意で実行
   */
  update() {

  }

  /**
   * ウィンドウリサイズ
   */
  resizeUpdate() {
    let winH = 'auto';

    // ブラウザ幅によって処理を分岐する
    if (AnyStore.setDevice() === 'pc') {
      // PC
      winH = window.innerHeight + 'px';
    }

    document.querySelectorAll(this.elSelector).forEach((el, index) => {
      el.style.height = winH;
    });
  }

  /**
   * 削除
   */
  destroy() {
    ResizeWatch.cancelObserver(this.name);
  }
}
